import { httpClientUser } from 'Api/microservice-http-clients';
import get from 'Utils/lodash.get';
import { isString } from 'Utils/common';
import BaseAuthModel from './BaseAuthModel';

const formParams = {
  email: {
    type: 'email',
    validate: {
      email: true,
      maxLength: 255,
      minLength: 5,
      required: true,
    },
  },
  password: {
    type: 'password',
    validate: {
      maxLength: 255,
      required: true,
    },
  },
};

export default class LoginAuthModel extends BaseAuthModel {
  constructor(data) {
    super(data);

    this.$scrollTopOnSuccess = false;
    this.$fbMethod = 'signInWithEmailAndPassword';
    // this.$gtmEvent = 'at.login';
    this._setParams(formParams);
  }

  get _sendArgs() {
    return [this.email, this.password];
  }

  _getGeneralError(error) {
    const apiError = get(error, 'response.data');
    if (isString(apiError)) return apiError;
    return super._getGeneralError(apiError || error);
  }

  _sendLoginError(error) {
    try {
      httpClientUser.post('/login/fail', { email: this.email, error });
    } catch (ignore) {} // eslint-disable-line
  }

  _onSendError(error) {
    this._sendLoginError(error.description || error.error_description);
    return super._onSendError(error);
  }
}
